import { render, staticRenderFns } from "./SuggestedDocumentModal.vue?vue&type=template&id=171a0c85"
import script from "./SuggestedDocumentModal.vue?vue&type=script&lang=ts"
export * from "./SuggestedDocumentModal.vue?vue&type=script&lang=ts"
import style0 from "./SuggestedDocumentModal.vue?vue&type=style&index=0&id=171a0c85&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports